export default __webpack_public_path__ + "static/media/infographie_etapes_2.01cac693.png";